export const ru = {
  publishing: {
    due: {
      title: 'К публикации',
      subtitle: 'Время этих публикаций наступило. Откройте пакет, опубликуйте вручную и отметьте выход.',
      empty: 'Сейчас публиковать нечего',
      emptyText: 'Когда подойдёт время по плану, публикации появятся здесь.',
      overdue: 'просрочено на {time}',
      onTime: 'по плану',
      open: 'Открыть пакет',
    },
    package: {
      back: '← К публикации',
      caption: 'Подпись',
      copy: 'Скопировать подпись',
      copied: 'Подпись скопирована',
      copyFailed: 'Не удалось скопировать — выделите текст вручную.',
      droppedTags: 'Не вошли в подпись (лимит канала): {tags}',
      media: 'Медиа по порядку',
      noMedia: 'У поста нет медиа.',
      zip: 'Скачать всё (ZIP)',
      share: 'Поделиться / сохранить в галерею',
      shareFailed: 'Не удалось поделиться — скачайте файлы по одному.',
      rendition: 'JPEG-копия',
      openChannel: 'Открыть канал',
      issues: 'Предупреждения',
      markTitle: 'Отметить выход',
      url: 'Ссылка на вышедший пост',
      urlHint: 'Необязательно. Например, https://t.me/канал/123',
      publishedAt: 'Время выхода',
      publishedAtHint: 'По умолчанию — сейчас.',
      mark: 'Опубликовано',
      early: 'Время ещё не наступило — выход будет досрочным, слот освободится для очереди.',
      cancelTitle: 'Не публиковать',
      cancelNote: 'Комментарий',
      cancel: 'Отменить публикацию',
      done: 'Публикация отмечена: {status}',
      openPost: 'Открыть пост',
    },
    history: {
      title: 'История публикаций',
      empty: 'Пост ещё не публиковался.',
      record: 'Записать выход вне системы',
      recordHint: 'Если пост уже выходил до системы или мимо неё.',
      channel: 'Канал',
      at: 'Когда вышел',
      url: 'Ссылка',
      save: 'Записать',
      withdrawn: 'пост снят с публикации',
      openPackage: 'Пакет',
      edit: 'Исправить выход',
      delete: 'Удалить выход',
      deleteConfirm: 'Удалить выход в «{channel}» {at}?',
      deleteText: 'Запись пропадёт из истории поста. Статус поста не изменится: если пост больше нигде не выходил, поменяйте статус сами.',
    },
  },
};

export const en: typeof ru = {
  publishing: {
    due: {
      title: 'Ready to publish',
      subtitle: 'These publications are due. Open the package, publish manually and mark it.',
      empty: 'Nothing to publish right now',
      emptyText: 'Publications appear here when their time comes.',
      overdue: 'overdue by {time}',
      onTime: 'on time',
      open: 'Open package',
    },
    package: {
      back: '← Ready to publish',
      caption: 'Caption',
      copy: 'Copy caption',
      copied: 'Caption copied',
      copyFailed: "Couldn't copy — select the text manually.",
      droppedTags: 'Left out of the caption (channel limit): {tags}',
      media: 'Media in order',
      noMedia: 'The post has no media.',
      zip: 'Download all (ZIP)',
      share: 'Share / save to gallery',
      shareFailed: "Couldn't share — download files one by one.",
      rendition: 'JPEG copy',
      openChannel: 'Open channel',
      issues: 'Warnings',
      markTitle: 'Mark as published',
      url: 'Link to the published post',
      urlHint: 'Optional, e.g. https://t.me/channel/123',
      publishedAt: 'Published at',
      publishedAtHint: 'Defaults to now.',
      mark: 'Published',
      early: "The time hasn't come yet — publishing early frees the slot for the queue.",
      cancelTitle: "Don't publish",
      cancelNote: 'Comment',
      cancel: 'Cancel publication',
      done: 'Publication marked: {status}',
      openPost: 'Open post',
    },
    history: {
      title: 'Publication history',
      empty: "The post hasn't been published yet.",
      record: 'Record an external publication',
      recordHint: 'If the post was published before the system or outside it.',
      channel: 'Channel',
      at: 'Published at',
      url: 'Link',
      save: 'Record',
      withdrawn: 'post withdrawn',
      openPackage: 'Package',
      edit: 'Edit publication',
      delete: 'Delete publication',
      deleteConfirm: 'Delete the publication in “{channel}” on {at}?',
      deleteText: "The record disappears from the post history. The post status won't change: if the post wasn't published anywhere else, change its status yourself.",
    },
  },
};
